export default "__VITE_ASSET__CscmsoXX__"